import ProfileDetailsLoader from "../ProfileDetailsLoader";

const PetDetailsLoader = () => {
    return (
        <div className="px-2 py-1.5 bg-white border-b-[rgba(128,141,160,0.2)] border-b-2">
            <ProfileDetailsLoader variant="customer" className="space-y-3 md:space-y-0" />
        </div>
    );
};
export default PetDetailsLoader;
